import { DeviceComponentProps } from '../types'
import UiStatus from './components/UiStatus'
import EquipmentStatus from './components/EquipmentStatus'

function DeviceStatus({ equipment, uiDevice }: DeviceComponentProps) {
  return (
    <>
      <EquipmentStatus equipment={equipment} />
      <UiStatus uiDevice={uiDevice} />
    </>
  )
}

export default DeviceStatus
